<template>
  <el-button
     size="mini"
    :class="{ 'is-icon-mr-075': lock }"
    :type="type"
    @click="updateEditValue">
    <i v-if="lock" class="far fa-lock-alt"></i>{{ $t(label) }}
  </el-button>
</template>

<script>
export default {
  name: 'nuttrema-edit-lock-button',
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: null,
    },
    lock: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      default: 'label.edit',
    },
  },
  methods: {
    updateEditValue() {
      if (!this.lock) {
        const value = !this.edit;
        this.$emit('update:edit', value);
        this.$emit('change', value);
      }
    },
  },
  computed: {
    type() {
      return this.lock ? 'info' : (this.edit ? 'nuttrema-orange' : '');
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/ui/button/nuttrema-edit-lock-button.vue